import { styled } from 'config/stitches.config'

import { motion } from 'framer-motion'

export const StyledCursor = styled(motion.div, {
  position: 'fixed',
  display: 'flex',
  flexFlow: 'row',
  alignContent: 'center',
  justifyContent: 'center',
  top: -5,
  left: -5,
  height: 0,
  width: 0,
  padding: 0,
  textAlign: 'center',
  fontSize: '$2',
  color: '$white',
  br: '$round',
  backgroundColor: '$white',
  pointerEvents: 'none',
  mixBlendMode: 'difference',
  zIndex: 1000,

  '.cursorText': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    flex: 'auto',
    fontSize: 'inherit',
    pointerEvents: 'none',
    margin: 'auto',
  }
})
